"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class MenuItemDto {
    constructor(params) {
        this.title = "";
        this.type = "";
        this.value = "";
        this.tutorialText = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.title = params.title;
        this.type = params.type;
        this.value = params.value;
        this.tutorialText = params.tutorialText;
        this.order = params.order;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.MenuItemDto = MenuItemDto;
//# sourceMappingURL=MenuItemDto.js.map